import React, { FC, useContext, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Button,
  AppBar,
  Toolbar,
  Container,
  Box,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import logo from "../../assets/images/HeaderLogo.svg";
import darkLogo from '../../assets/images/HeaderLogoDark.svg'
import { HeaderStyle } from "../Styles/LandingStyles";
import MomentCounter from "../../helpers/MomentCounter";
import { HeaderProps } from "../../interfaces";
import CloseIcon from "@material-ui/icons/Close";

import gql from "graphql-tag";
import { useGraphQLQuery } from "../../utils/grapgql/react-query-graphql.util";
import { Colors } from "../../helpers/theme";
import AuthContext from "../../store/Auth/AuthContext";

const Header: FC<HeaderProps> = ({ authPage, timer, loginPage, redirect }) => {
  const theme = useTheme();
  const classes = HeaderStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("xs"));
  const isActiveSM = useMediaQuery(theme.breakpoints.down("sm"));
  const [dataa, setdataa] = useState<any>();
  const [isSticky, setSticky] = useState(false);
  const [closeBanner, setcloseBanner] = useState(false);
  const { isAuth } = useContext<any>(AuthContext);
  const [isAlertAnimation, setalertAnimation] = useState(false);

  const LIVEPOOLS_QUERY = gql`
    query getLivePoolsAlerts {
      getLivePoolsAlerts {
        id
        name
        image
        contributionStartDate
        contributionEndDate
        pledgeStartDate
        pledgeEndDate
        totalCap
        totalRaised
        status
      }
    }
  `;
  const { data, error, isLoading } = useGraphQLQuery<any, any, any>(
    LIVEPOOLS_QUERY
  );
  const [index, setindex] = useState<any>(0);

  useEffect(() => {
    if (data) {
      setdataa(data?.getLivePoolsAlerts);
      setindex(0);
      setalertAnimation(true);
    }
  }, [data]);

  useEffect(() => {
    const timeId = setInterval(handleIndex, 5000);
    if (index > dataa?.length - 1) {
      setindex(0);
      setalertAnimation(true);
    }
    return () => {
      clearInterval(timeId);
      setalertAnimation(true);
    };
  }, [index]);

  const handleIndex = () => {
    setindex(index + 1);
    setalertAnimation(true);
  };
  const handleCloseBanner = () => {
    setcloseBanner(true);
  };

  // const handleOpenBanner = () => {
  //   setcloseBanner(false);
  // };

  // scroller EventHandler for header Animation
  useEffect(() => {
    //for sticky
    window.addEventListener("scroll", () => {
      const isTop = window.scrollY > 250;
      if (isTop) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    });
  }, []);

  return (
    <>
      <AppBar
        // data-aos="fade-in"
        data-aos-duration="1200"
        className={`${loginPage || authPage ? classes.headerRoot : classes.root}  ${isSticky ? `${classes.sticky}` : ""}`}
        position="sticky"
        color="transparent"
      >
        <Container fixed>
          <Toolbar className="header-toolbar" disableGutters={true}>
            <Box component="div" className={classes.grow}>
              <NavLink to="/">
                <img src={ authPage ? darkLogo : logo } alt="logo" className={classes.logo} />
              </NavLink>
            </Box>

            {authPage && !isActive ? (
              // for desktop screen auth pages
              <>
                {/* if login then show signup  */}
                {loginPage ? (
                  <>
                    <Typography variant="body1" color="secondary">
                      Don’t have an account? {"  "}
                    </Typography>

                    <NavLink to={"/signup" + (redirect ? `?ref=${redirect}` : "")}>
                      <Typography
                        className="fw-bold "
                        variant="body1"
                        component="span"
                        color="primary"
                      >
                        {" "}
                        Sign Up
                      </Typography>
                    </NavLink>
                  </>
                ) : (
                  // else show login
                  <>
                    <Typography variant="body1" color="secondary">
                      Already have an account? {"  "}{" "}
                    </Typography>{" "}
                    <NavLink to={"/login" + (redirect ? `?ref=${redirect}` : "")}>
                      <Typography
                        className="fw-bold"
                        variant="body1"
                        component="span"
                        color="primary"
                      >
                        {" "}
                        Sign In
                      </Typography>
                    </NavLink>
                  </>
                )}
              </>
            ) : (
              <>
                {/* for desktop show */}
                {/* {!isActive && (
                  <NavLink to="/all-projects" className="fs-14 hero-blue">
                    Tutorial Videos
                  </NavLink>
                )} */}
                <Box className={classes.headerbtns} display="flex">
                  {/* for auth pages in mobile view  */}
                  {authPage && !loginPage ? (
                    <>
                      <NavLink to={"/login" + (redirect ? `?ref=${redirect}` : "")}>
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          classes={{ label: "fs12" }}
                        >
                          Sign In
                        </Button>
                      </NavLink>
                    </>
                  ) : (
                    <>
                      {!loginPage && !isAuth && (
                        <NavLink to={"/login" + (redirect ? `?ref=${redirect}` : "")}>
                          <Button
                            variant="outlined"
                            className={classes.containedButton}
                            size="small"
                            classes={{ label: "fs12" }}
                          >
                            Sign In
                          </Button>
                        </NavLink>
                      )}
                      <NavLink to={(isAuth ? "/login" : "/signup") + (redirect ? `?ref=${redirect}` : "")}>
                        <Button
                          variant="contained"
                          size="small"
                          classes={{ label: "fs12" }}
                          className={`${classes.filledButton} ${loginPage ? classes.mobile : ''}`}
                        >
                          {isAuth ? "My Account" : "Sign Up"}
                        </Button>
                      </NavLink>
                    </>
                  )}

                  {/* {!isActive && (
                  
                  )} */}
                </Box>
              </>
            )}
          </Toolbar>
        </Container>

        {/*  */}
      </AppBar>
    </>
  );
};

export default Header;
